import React from "react";
import PropTypes from "prop-types";
import { conditionallyAddStyles } from "../../support/helpers";

const propTypes = {
  active: PropTypes.bool.isRequired,
  tab: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

const Tab = ({ active, tab, onClick }) => {
  const defaultClasses = [
    "p-4",
    "md:p-6",
    "uppercase",
    "heading-5",
    "border-b-2",
  ];

  conditionallyAddStyles(
    active,
    defaultClasses,
    "border-black",
    "border-transparent"
  );

  return (
    <button key={tab} onClick={onClick}>
      <div className={defaultClasses.join(" ")}>{tab}</div>
    </button>
  );
};

Tab.propTypes = propTypes;

export default Tab;
